import React, { useState } from 'react';
import {
    Box,
    Typography,
    Select,
    MenuItem,
    Card,
} from '@mui/material';
import {  Button} from '@mui/joy';

import StarIcon from '@mui/icons-material/Star';
import BiddersCard from './cardsection/BiddersCard';

const Reviews = ({ rating, setRating }) => {
    const [hover, setHover] = useState(null);

    return (
        <Box sx={{ display: 'flex', gap: '5px' }}>
            {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return (
                    <StarIcon
                        key={index}
                        style={{
                            cursor: 'pointer',
                            color: starValue <= (hover || rating) ? '#ffc107' : '#e4e5e9',
                        }}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(starValue)}
                    />
                );
            })}
        </Box>
    );
};

const initialData = [
    { id: 1, name: 'Rocky rock', skill: 'Plumbing, Cleaning, Appliance Repair', location: 'London', price: 120, rating: 4 },
    { id: 2, name: 'Rocky rock', skill: 'Plumbing, Cleaning, Appliance Repair', location: 'New York', price: 100, rating: 3 },
    { id: 3, name: 'Rocky rock', skill: 'Plumbing, Cleaning, Appliance Repair', location: 'Berlin', price: 140, rating: 5 },
    { id: 4, name: 'Rocky rock', skill: 'Plumbing, Cleaning, Appliance Repair', location: 'Paris', price: 110, rating: 4 },
];

const Bidders = () => {
    const [data, setData] = useState(initialData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('price');

    const handleSortChange = (value) => {
        const [newOrder, newOrderBy] = value.split('-');
        setOrder(newOrder);
        setOrderBy(newOrderBy);
    };

    const sortedData = [...data].sort((a, b) => {
        if (orderBy === 'price') {
            return order === 'asc' ? a.price - b.price : b.price - a.price;
        } else if (orderBy === 'rating') {
            return order === 'asc' ? a.rating - b.rating : b.rating - a.rating;
        }
        return 0;
    });

    const updateRating = (id, newRating) => {
        setData((prevData) =>
            prevData.map((item) => (item.id === id ? { ...item, rating: newRating } : item))
        );
    };

    return (
        <Box sx={{
            width: '806px',
            margin: '2rem auto',
            maxWidth:'100%'
       
        }}>
          
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, }}>
                <Select
                    value={`${order}-${orderBy}`}
                    onChange={(e) => handleSortChange(e.target.value)}
                    displayEmpty
                    size='small'
                    sx={{ minWidth: 200 }}
                >
                    <MenuItem value='asc-price'>Ascending to Price</MenuItem>
                    <MenuItem value='desc-price'>Descending to Price</MenuItem>
                    <MenuItem value='asc-rating'>Descending to Rating</MenuItem>
                    <MenuItem value='desc-rating'>Ascending to Rating</MenuItem>
                </Select>
            </Box>

            {/* Data */}

            {sortedData?.map((profile) => (
                <Box
                    key={profile.id}

                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        mb: 2,
                        p: 2,
                        borderBottom: '0.5px solid rgba(0, 0, 0, 0.50)',

                        width: '806px',

                        maxWidth:'100%'

                    }}
                >
                   
                    <Box sx={{ maxWidth: 161 }}>
                        <BiddersCard />
                    </Box>

                    
                    <Box sx={{ flex: 1, px: 2 }}>
                        <Typography variant='h5' sx={{ fontWeight: 'bold' }}>
                            {profile.name}
                        </Typography>
                        <Reviews
                            rating={profile.rating}
                            setRating={(newRating) => updateRating(profile.id, newRating)}
                        />
                        <Typography sx={{ mt: 1 }}>{profile.skill}</Typography>
                        <Typography>Location - {profile.location}</Typography>
                    </Box>

                    <Card
                            sx={{

                                padding: "10px",
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'start',
                                textAlign: 'center',
                                boxShadow: 'none',
                                height: '150px',
                            }}
                        >

                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    fontWeight: 'bold',
                                    marginBottom: 2, 
                                }}
                            >
                               £ {profile.price}
                            </Typography>


                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 1.5,
                                    width: '100%',
                                    '& > button': {
                                        flex: 1, 
                                    },
                                }}
                            >
                                <Button variant="outlined"
                                    sx={{

                                        backgroundColor: "#fff",
                                        width: "87px",
                                        height: "36px",
                                        borderRadius: "6px",
                                        color: "#28A745",
                                        border: "0.5px solid #28A745",
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        lineHeight: "19.5px",
                                        "&:hover": {
                                            backgroundColor: "#ffe",
                                            color: "#28A745", boxShadow: 3,
                                        }


                                    }}
                                >
                                    Chat
                                </Button>
                                <Button variant="contained"
                                    sx={{
                                        backgroundColor: "#28A745",
                                        width: "87px",
                                        height: "36px",
                                        borderRadius: "6px",
                                        color: "#fff",
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        lineHeight: "19.5px"
                                    }}

                                >
                                    Follow
                                </Button>
                            </Box>
                        </Card>

                </Box>
            ))}

        </Box>
    );
}

export default Bidders;